var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              ref: "dragDialog",
              staticClass: "gl-new-dialogPop",
              attrs: {
                title: _vm.$t("blExchangeAppointment.foreSpeak"),
                isShowFollow: false,
                fullscreen: _vm.fullscreenSize,
              },
              on: { opened: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { rules: _vm.rules, model: _vm.form } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "vvLBlNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.voyageNoBlNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    disabled: true,
                                    autosize: { minRows: 2, maxRows: 4 },
                                  },
                                  model: {
                                    value: _vm.vvLBlNo,
                                    callback: function ($$v) {
                                      _vm.vvLBlNo = $$v
                                    },
                                    expression: "vvLBlNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "forespeakStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.forespeakStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.forespeakStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "forespeakStatus",
                                          $$v
                                        )
                                      },
                                      expression: "form.forespeakStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.forespeakStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.paymentStatus,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentStatus", $$v)
                                      },
                                      expression: "form.paymentStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.paymentStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentMethod",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentMethod"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.form.paymentMethod,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentMethod", $$v)
                                      },
                                      expression: "form.paymentMethod",
                                    },
                                  },
                                  _vm._l(_vm.edoPaymentMethod, function (item) {
                                    return _c("el-option", {
                                      key: item.codeValue,
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "blExchangeAppointment.select"
                                        ),
                                        value: Number(item.codeValue),
                                        label:
                                          _vm.language === "zh"
                                            ? item.displayValueCn
                                            : item.displayValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceTitle",
                                  label: _vm.$t(
                                    "blExchangeAppointment.invoiceTitle"
                                  ),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 60,
                                    "fetch-suggestions":
                                      _vm.getQuerySearchAdapter("invoiceTitle"),
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  on: {
                                    blur: _vm.getCustomerEmail,
                                    select: _vm.getCustomerEmail,
                                  },
                                  model: {
                                    value: _vm.form.invoiceTitle,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceTitle", $$v)
                                    },
                                    expression: "form.invoiceTitle",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentNo"
                                  ),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 60,
                                    "fetch-suggestions":
                                      _vm.getQuerySearchAdapter("paymentNo"),
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.paymentNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "paymentNo", $$v)
                                    },
                                    expression: "form.paymentNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceTaxNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.invoiceTaxNo"
                                  ),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    "fetch-suggestions":
                                      _vm.getQuerySearchAdapter("invoiceTaxNo"),
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.invoiceTaxNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceTaxNo", $$v)
                                    },
                                    expression: "form.invoiceTaxNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceBankNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.invoiceBankNo"
                                  ),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    "fetch-suggestions":
                                      _vm.getQuerySearchAdapter(
                                        "invoiceBankNo"
                                      ),
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.invoiceBankNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceBankNo", $$v)
                                    },
                                    expression: "form.invoiceBankNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "address",
                                  label: _vm.$t(
                                    "blExchangeAppointment.address"
                                  ),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    "fetch-suggestions":
                                      _vm.getQuerySearchAdapter("address"),
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.address,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "phone",
                                  label: _vm.$t("blExchangeAppointment.phone"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "accountBank",
                                  label: _vm.$t(
                                    "blExchangeAppointment.accountBank"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.accountBank,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountBank", $$v)
                                    },
                                    expression: "form.accountBank",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "receiveEmail",
                                  label: _vm.$t(
                                    "blExchangeAppointment.receiveEmail"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: 60 },
                                  model: {
                                    value: _vm.form.receiveEmail,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "receiveEmail", $$v)
                                    },
                                    expression: "form.receiveEmail",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "powerAttorney",
                                  label: _vm.$t(
                                    "blExchangeAppointment.powerAttorney"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      action: "",
                                      "http-request":
                                        _vm.uploadPowerAttorneyFile,
                                      "on-remove":
                                        _vm.handledPowerAttorneyRemove,
                                      "before-remove": _vm.beforeRemove,
                                      multiple: "",
                                      limit: 1,
                                      accept: _vm.acceptList,
                                      "file-list": _vm.powerAttorneyFileList,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-upload2",
                                          size: "small",
                                          type: "primary",
                                          plain: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "blExchangeAppointment.selectFile"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.form.powerAttorney
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "blExchangeAppointment.notFileSelected"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "attachment",
                                  label: _vm.$t(
                                    "blExchangeAppointment.bankSlip"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    ref: "upload",
                                    staticClass: "upload-demo",
                                    attrs: {
                                      action: "",
                                      multiple: "",
                                      limit: 1,
                                      "http-request": _vm.uploadAttachmentFile,
                                      "on-remove": _vm.handleAttachmentRemove,
                                      "before-remove": _vm.beforeRemove,
                                      accept: _vm.acceptList,
                                      "file-list": _vm.attachmentFileList,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-upload2",
                                          size: "small",
                                          type: "primary",
                                          plain: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "blExchangeAppointment.selectFile"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.form.attachment
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "blExchangeAppointment.notFileSelected"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "doType" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.doType"
                                      ),
                                    },
                                    model: {
                                      value: _vm.doType,
                                      callback: function ($$v) {
                                        _vm.doType = $$v
                                      },
                                      expression: "doType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { disabled: true, label: 0 } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.electronicBill"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio",
                                      { attrs: { disabled: true, label: 1 } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.paperBill"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "accreditStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.accreditStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.accreditStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "accreditStatus",
                                          $$v
                                        )
                                      },
                                      expression: "form.accreditStatus",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.accreditStatusList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.codeValue,
                                          attrs: {
                                            value: Number(item.codeValue),
                                            label:
                                              _vm.language === "zh"
                                                ? item.displayValueCn
                                                : item.displayValue,
                                          },
                                        })
                                      }
                                    ),
                                    _vm._v(
                                      "\n                  />\n                "
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "cstName",
                                  label: _vm.$t(
                                    "blExchangeAppointment.accreditCustomer"
                                  ),
                                },
                              },
                              [
                                _c("gl-customer-sipg", {
                                  on: { change: _vm.selectSipgCstCodeChange },
                                  model: {
                                    value: _vm.form.cstName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "cstName", $$v)
                                    },
                                    expression: "form.cstName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h2", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("blExchangeAppointment.blExchangeRequirement")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(_vm.$t("blExchangeAppointment.blExchangeNote"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "p-color" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("blExchangeAppointment.blExchangeStep1")
                            ) +
                            "\n            "
                        ),
                        _c(
                          "el-link",
                          {
                            attrs: {
                              type: "danger",
                              href: "http://edo.sipg.com.cn/ContactList/Home/Index",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              "\n              http://edo.sipg.com.cn/ContactList/Home/Index\n            "
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "blExchangeAppointment.blExchangeStep1Part2"
                              )
                            ) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(_vm.$t("blExchangeAppointment.blExchangeStep2"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(_vm.$t("blExchangeAppointment.blExchangeStep3"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(_vm.$t("blExchangeAppointment.blExchangeStep4"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(_vm.$t("blExchangeAppointment.blExchangeStep5"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("blExchangeAppointment.contactInfo"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "item-button" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-info-primary",
                            on: { click: _vm.handleClose },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.close")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-info-primary",
                            on: { click: _vm.handlePrint },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.print")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-info-primary",
                            on: { click: _vm.handleDownloadAttorney },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.downloadAttorney")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showBtnCancel,
                                expression: "showBtnCancel",
                              },
                            ],
                            staticClass: "btn-info-primary",
                            on: { click: _vm.handleCancel },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.cancel")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleSave },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.forespeakSave")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }